/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrderDetailsRoutingModule
 * Purpose		: Routing module for OrderDetails.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { OrderDetailsListComponent } from './OrderDetailsList.component';
import { OrderDetailsAddComponent }  from './OrderDetailsAdd.component';
import { OrderDetailsEditComponent } from './OrderDetailsEdit.component';
import { OrderDetailsDetailsComponent } from './OrderDetailsDetails.component';

const OrderDetailsRoutes: Routes = [
	{ path: 'OrderDetails',  component: OrderDetailsListComponent },
	{ path: 'OrderDetails/add', component: OrderDetailsAddComponent },
	{ path: 'OrderDetails/:id', component: OrderDetailsEditComponent },
	{ path: 'OrderDetails/Details/:id', component: OrderDetailsDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(OrderDetailsRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class OrderDetailsRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrderDetails/OrderDetails-routing.module.ts